// extracted by mini-css-extract-plugin
export default {"container":"auth-login-with-sf-callback_container__4BZhA","heading":"auth-login-with-sf-callback_heading__TKWT9"};